import { LeadActivity, LeadActivityType } from "views/leads-id/types";

const AI_AGENT_ACTOR_TYPES: string[] = ["ai_leasing_agent", "ai_agent"];

export const isAiAgentActor = (actorType?: string): boolean =>
  Boolean(actorType && AI_AGENT_ACTOR_TYPES.includes(actorType));

export const getActorAttribution = (activity: LeadActivity): string => {
  if (activity.activity_type === LeadActivityType.AI_CALL_RECEIVED) return "";
  if (activity.activity_type === LeadActivityType.SHOWING_INVITE_SENT)
    return "";

  const isPartner = activity.actor_type === "partner";
  const isAiAgent = isAiAgentActor(activity.actor_type);
  if (!isPartner && !isAiAgent) return "";
  if (!activity.actor_name || activity.title.includes(activity.actor_name))
    return "";

  const agentLabel = isAiAgent ? " leasing agent" : "";
  return ` by ${activity.actor_name}${agentLabel}`;
};
